import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC } from "react"
import { useNavigation } from "../../hooks/useNavigation"
import { colors } from "../../utils/theme"
import { PrimaryButton } from "../atoms/button/Button"
import Logo from "../atoms/Logo"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: theme.spacing(6),
    left: theme.spacing(6),
  },
  button: {
    width: "100%",
  },
  marginBottom32: {
    marginBottom: theme.spacing(4),
  },
  denim: {
    color: colors.neutral.denim,
  },
}))

const ResetPasswordSuccess: FC = () => {
  const classes = useStyles()
  const { toLogin } = useNavigation()

  return (
    <BaseTemplate>
      <Logo className={classes.logo} />
      <TitledCard title="Success!">
        <Typography
          variant="body1"
          className={clsx(classes.marginBottom32, classes.denim)}
        >
          Your password has been reset. Please select continue to login with
          your new password.
        </Typography>
        <PrimaryButton className={classes.button} onClick={toLogin}>
          Continue
        </PrimaryButton>
      </TitledCard>
    </BaseTemplate>
  )
}

export default ResetPasswordSuccess
